import script from "./addPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./addPlan.vue?vue&type=script&setup=true&lang=js"

import "./addPlan.vue?vue&type=style&index=0&id=7020ec06&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7020ec06"]])

export default __exports__